var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.25C5.74168 9.25 6.4667 9.03007 7.08339 8.61801C7.70007 8.20596 8.18072 7.62029 8.46455 6.93506C8.74838 6.24984 8.82264 5.49584 8.67794 4.76841C8.53325 4.04098 8.1761 3.3728 7.65165 2.84835C7.1272 2.3239 6.45902 1.96675 5.73159 1.82206C5.00416 1.67736 4.25016 1.75162 3.56494 2.03545C2.87971 2.31928 2.29404 2.79993 1.88199 3.41661C1.46993 4.0333 1.25 4.75832 1.25 5.5C1.25 6.12 1.4 6.70459 1.66667 7.21959L1.25 9.25L3.28042 8.83333C3.79542 9.1 4.38042 9.25 5 9.25Z",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.13b31bcb1cb805d9ec87aa9d9f2778a5.svg";
export { ForwardRef as ReactComponent };